


















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";
import ILabel from "../types/label";
import { copy } from "../util/object";

function arrayToObject(arr: string[]) {
  let obj = {} as Record<string, boolean>;
  for (const str of arr) {
    obj[str] = true;
  }
  return obj;
}

@Component
export default class LabelFilter extends Vue {
  @Prop({ default: () => [] }) value!: any;
  @Prop({ default: () => [] }) items!: ILabel[];

  @Watch("value", { deep: true })
  onValueChange(val: any) {
    this.include = arrayToObject(this.value.include);
    this.exclude = arrayToObject(this.value.exclude);
  }

  innerValue = [...this.value.include, ...this.value.exclude] as string[];
  include = arrayToObject(this.value.include) as Record<string, boolean>;
  exclude = arrayToObject(this.value.exclude) as Record<string, boolean>;

  emit() {
    this.$emit("change", {
      include: Object.keys(this.include),
      exclude: Object.keys(this.exclude)
    });
    this.$emit("input", {
      include: Object.keys(this.include),
      exclude: Object.keys(this.exclude)
    });
  }

  onChange(ids: string[]) {
    const newIncluded = {};
    const newExcluded = {};
    for (const id of ids) {
      const label = <ILabel>this.items.find(l => l._id == id);
      if (!this.isUsed(id) || this.isIncluded(id)) newIncluded[id] = label;
      else if (this.isExcluded(id)) newExcluded[id] = label;
    }
    this.include = newIncluded;
    this.exclude = newExcluded;
    this.emit();
  }

  isUsed(id: string) {
    return !!this.include[id] || !!this.exclude[id];
  }

  isExcluded(id: string) {
    return !!this.exclude[id];
  }

  isIncluded(id: string) {
    return !!this.include[id];
  }

  removeLabel(id: string) {
    delete this.include[id];
    delete this.exclude[id];
    this.innerValue = this.innerValue.filter(l => l != id);
    this.emit();
  }

  toggleLabel(id: string) {
    if (this.isIncluded(id)) {
      delete this.include[id];
      this.exclude[id] = true;
    } else {
      delete this.exclude[id];
      this.include[id] = true;
    }
    this.emit();
  }
}
